import {
  clearAuthenticatedEntidadeId,
  getAuthenticatedEntidadeId,
  setAuthenticatedEntidadeId,
} from './authenticated-entidade'
import {
  getBackendAvailabilityState,
  subscribeBackendAvailability,
} from './backend-availability'

export type {
  BuyerBeneficios,
  BuyerAccessStatus,
  BuyerDistribuicao,
  BuyerRotatingSearchTerm,
  BuyerRotatingSearchTermsResponse,
  StorefrontRotatingSearchTermsResponse,
  BuyerStoreUser,
  BuyerStoreUserInput,
  MarketplaceVitrineAnuncio,
  MarketplaceVitrineAnuncioInput,
  MarketplaceVitrineCondicao,
  MarketplaceVitrineCategoria,
  MarketplaceVitrineContatoCanal,
  MarketplaceVitrineManual,
  MarketplaceVitrineMetricas,
  MarketplaceVitrineMetricasAnuncio,
  MarketplaceVitrineMetricasCanais,
  MarketplaceVitrineMetricasDiarias,
  MarketplaceVitrineMetricasResumo,
  MarketplaceVitrinePergunta,
  MarketplaceVitrinePerfil,
  ClienteMercadoLivreConfiguracao,
  ClienteMercadoLivreEmissor,
  ClienteMercadoLivreEmissorInput,
  ClienteMercadoLivreNotificacao,
  ClienteMercadoLivrePedido,
  ClienteMercadoLivreRegraFiscal,
  ClienteMercadoLivreRegraFiscalInput,
  ClienteMercadoLivreSimulacaoFiscalInput,
  ClienteMercadoLivreSimulacaoFiscalResultado,
  ClienteMercadoLivreCertificadoPfx,
  ClienteMercadoLivreProdutoOpcoes,
  ClienteMercadoLivreAnuncio,
  ClienteMercadoLivreAnuncioRascunhoInput,
  ClienteMercadoLivreSimulacaoPrecoInput,
  ClienteMercadoLivreSimulacaoPrecoResultado,
  MarketplaceVitrineVariacao,
  MarketplaceVitrineVideo,
  BuyerPasswordChangeChannel,
  BuyerPasswordChangeDestinationsResult,
  BuyerPasswordChangeRequestResult,
  BuyerPasswordChangeResetResult,
  BuyerPasswordChangeVerifyResult,
  CheckoutCustomerProfile,
  CheckoutOrderResult,
  HomeProductShowcasesResult,
  StorefrontCategoryModel,
  PasswordlessContactRequestResult,
  PasswordlessDestinationsResult,
  PaginatedFilteredProductListResult,
  PaginatedProductListResult,
  PedidoAcompanhamentoMilestone,
  PedidoAcompanhamentoResult,
  PasswordlessLoginChannel,
  PasswordlessLoginRequestResult,
  PasswordlessWhatsappDestination,
  PasswordRecoveryChannel,
  PasswordRecoveryDestinationsResult,
  PasswordRecoveryRequestResult,
  PasswordRecoveryResetResult,
  PasswordRecoveryVerifyResult,
  StorefrontManufacturerBrand,
  StorefrontSiteConfig,
  StorefrontVehicleOption,
  StorefrontVehiclePlate,
  SavedQuotePdfClient,
} from './api'
export { clearAuthenticatedEntidadeId, getAuthenticatedEntidadeId, getBackendAvailabilityState, setAuthenticatedEntidadeId, subscribeBackendAvailability }

type ApiModule = typeof import('./api')

const loadApi = () => import('./api')

export const checkClienteExists: ApiModule['checkClienteExists'] = async (...args) => {
  const api = await loadApi()
  return api.checkClienteExists(...args)
}

export const clearCarrinho: ApiModule['clearCarrinho'] = async (...args) => {
  const api = await loadApi()
  return api.clearCarrinho(...args)
}

export const replaceOrcamento: ApiModule['replaceOrcamento'] = async (...args) => {
  const api = await loadApi()
  return api.replaceOrcamento(...args)
}

export const copyCarrinhoBetweenCompradores: ApiModule['copyCarrinhoBetweenCompradores'] = async (...args) => {
  const api = await loadApi()
  return api.copyCarrinhoBetweenCompradores(...args)
}

export const consumeBuyerAccessTicket: ApiModule['consumeBuyerAccessTicket'] = async (...args) => {
  const api = await loadApi()
  return api.consumeBuyerAccessTicket(...args)
}

export const consumeBuyerAccessShortCode: ApiModule['consumeBuyerAccessShortCode'] = async (...args) => {
  const api = await loadApi()
  return api.consumeBuyerAccessShortCode(...args)
}

export const getPedidoAcompanhamentoByCode: ApiModule['getPedidoAcompanhamentoByCode'] = async (...args) => {
  const api = await loadApi()
  return api.getPedidoAcompanhamentoByCode(...args)
}

export const solicitarPedidoAcompanhamentoWhatsappNotificationSubscription: ApiModule['solicitarPedidoAcompanhamentoWhatsappNotificationSubscription'] = async (...args) => {
  const api = await loadApi()
  return api.solicitarPedidoAcompanhamentoWhatsappNotificationSubscription(...args)
}

export const forgotPassword: ApiModule['forgotPassword'] = async (...args) => {
  const api = await loadApi()
  return api.forgotPassword(...args)
}

export const getAcabaramDeChegarPage: ApiModule['getAcabaramDeChegarPage'] = async (...args) => {
  const api = await loadApi()
  return api.getAcabaramDeChegarPage(...args)
}

export const getHomeProductShowcases: ApiModule['getHomeProductShowcases'] = async (...args) => {
  const api = await loadApi()
  return api.getHomeProductShowcases(...args)
}

export const getBuyerAccountSummary: ApiModule['getBuyerAccountSummary'] = async (...args) => {
  const api = await loadApi()
  return api.getBuyerAccountSummary(...args)
}

export const getBuyerRotatingSearchTerms: ApiModule['getBuyerRotatingSearchTerms'] = async (...args) => {
  const api = await loadApi()
  return api.getBuyerRotatingSearchTerms(...args)
}

export const getStorefrontRotatingSearchTerms: ApiModule['getStorefrontRotatingSearchTerms'] = async (...args) => {
  const api = await loadApi()
  return api.getStorefrontRotatingSearchTerms(...args)
}

export const searchFilteredProductsPage: ApiModule['searchFilteredProductsPage'] = async (...args) => {
  const api = await loadApi()
  return api.searchFilteredProductsPage(...args)
}

export const searchMarketplaceVitrineProductsPage: ApiModule['searchMarketplaceVitrineProductsPage'] = async (...args) => {
  const api = await loadApi()
  return api.searchMarketplaceVitrineProductsPage(...args)
}

export const getBuyerStoreUsers: ApiModule['getBuyerStoreUsers'] = async (...args) => {
  const api = await loadApi()
  return api.getBuyerStoreUsers(...args)
}

export const createBuyerStoreUser: ApiModule['createBuyerStoreUser'] = async (...args) => {
  const api = await loadApi()
  return api.createBuyerStoreUser(...args)
}

export const updateBuyerStoreUser: ApiModule['updateBuyerStoreUser'] = async (...args) => {
  const api = await loadApi()
  return api.updateBuyerStoreUser(...args)
}

export const getMarketplaceVitrinePerfil: ApiModule['getMarketplaceVitrinePerfil'] = async (...args) => {
  const api = await loadApi()
  return api.getMarketplaceVitrinePerfil(...args)
}

export const getClienteMercadoLivreConfiguracao: ApiModule['getClienteMercadoLivreConfiguracao'] = async (...args) => {
  const api = await loadApi()
  return api.getClienteMercadoLivreConfiguracao(...args)
}

export const getClienteMercadoLivreAtividade: ApiModule['getClienteMercadoLivreAtividade'] = async (...args) => {
  const api = await loadApi()
  return api.getClienteMercadoLivreAtividade(...args)
}

export const getClienteMercadoLivrePedidos: ApiModule['getClienteMercadoLivrePedidos'] = async (...args) => {
  const api = await loadApi()
  return api.getClienteMercadoLivrePedidos(...args)
}

export const createClienteMercadoLivreConnectionLink: ApiModule['createClienteMercadoLivreConnectionLink'] = async (...args) => {
  const api = await loadApi()
  return api.createClienteMercadoLivreConnectionLink(...args)
}

export const verifyClienteMercadoLivreConta: ApiModule['verifyClienteMercadoLivreConta'] = async (...args) => {
  const api = await loadApi()
  return api.verifyClienteMercadoLivreConta(...args)
}

export const disconnectClienteMercadoLivreConta: ApiModule['disconnectClienteMercadoLivreConta'] = async (...args) => {
  const api = await loadApi()
  return api.disconnectClienteMercadoLivreConta(...args)
}

export const saveClienteMercadoLivreEmissor: ApiModule['saveClienteMercadoLivreEmissor'] = async (...args) => {
  const api = await loadApi()
  return api.saveClienteMercadoLivreEmissor(...args)
}

export const getClienteMercadoLivreRegrasFiscais: ApiModule['getClienteMercadoLivreRegrasFiscais'] = async (...args) => {
  const api = await loadApi()
  return api.getClienteMercadoLivreRegrasFiscais(...args)
}

export const saveClienteMercadoLivreRegraFiscal: ApiModule['saveClienteMercadoLivreRegraFiscal'] = async (...args) => {
  const api = await loadApi()
  return api.saveClienteMercadoLivreRegraFiscal(...args)
}

export const simularClienteMercadoLivreRegraFiscal: ApiModule['simularClienteMercadoLivreRegraFiscal'] = async (...args) => {
  const api = await loadApi()
  return api.simularClienteMercadoLivreRegraFiscal(...args)
}

export const getClienteMercadoLivreCertificadoPfx: ApiModule['getClienteMercadoLivreCertificadoPfx'] = async (...args) => {
  const api = await loadApi()
  return api.getClienteMercadoLivreCertificadoPfx(...args)
}

export const uploadClienteMercadoLivreCertificadoPfx: ApiModule['uploadClienteMercadoLivreCertificadoPfx'] = async (...args) => {
  const api = await loadApi()
  return api.uploadClienteMercadoLivreCertificadoPfx(...args)
}

export const getClienteMercadoLivreAnuncios: ApiModule['getClienteMercadoLivreAnuncios'] = async (...args) => {
  const api = await loadApi()
  return api.getClienteMercadoLivreAnuncios(...args)
}

export const getClienteMercadoLivreProdutoOpcoes: ApiModule['getClienteMercadoLivreProdutoOpcoes'] = async (...args) => {
  const api = await loadApi()
  return api.getClienteMercadoLivreProdutoOpcoes(...args)
}

export const getClienteMercadoLivrePrecoBrasiltec: ApiModule['getClienteMercadoLivrePrecoBrasiltec'] = async (...args) => {
  const api = await loadApi()
  return api.getClienteMercadoLivrePrecoBrasiltec(...args)
}

export const sugerirClienteMercadoLivreCategorias: ApiModule['sugerirClienteMercadoLivreCategorias'] = async (...args) => {
  const api = await loadApi()
  return api.sugerirClienteMercadoLivreCategorias(...args)
}

export const listarClienteMercadoLivreTiposAnuncio: ApiModule['listarClienteMercadoLivreTiposAnuncio'] = async (...args) => {
  const api = await loadApi()
  return api.listarClienteMercadoLivreTiposAnuncio(...args)
}

export const simularClienteMercadoLivrePreco: ApiModule['simularClienteMercadoLivrePreco'] = async (...args) => {
  const api = await loadApi()
  return api.simularClienteMercadoLivrePreco(...args)
}

export const createClienteMercadoLivreAnuncioRascunho: ApiModule['createClienteMercadoLivreAnuncioRascunho'] = async (...args) => {
  const api = await loadApi()
  return api.createClienteMercadoLivreAnuncioRascunho(...args)
}

export const discardClienteMercadoLivreAnuncioRascunho: ApiModule['discardClienteMercadoLivreAnuncioRascunho'] = async (...args) => {
  const api = await loadApi()
  return api.discardClienteMercadoLivreAnuncioRascunho(...args)
}

export const saveMarketplaceVitrinePerfil: ApiModule['saveMarketplaceVitrinePerfil'] = async (...args) => {
  const api = await loadApi()
  return api.saveMarketplaceVitrinePerfil(...args)
}

export const getMarketplaceVitrineSellerAnuncios: ApiModule['getMarketplaceVitrineSellerAnuncios'] = async (...args) => {
  const api = await loadApi()
  return api.getMarketplaceVitrineSellerAnuncios(...args)
}

export const getMarketplaceVitrineMetricas: ApiModule['getMarketplaceVitrineMetricas'] = async (...args) => {
  const api = await loadApi()
  return api.getMarketplaceVitrineMetricas(...args)
}

export const getMarketplaceVitrineCategorias: ApiModule['getMarketplaceVitrineCategorias'] = async (...args) => {
  const api = await loadApi()
  return api.getMarketplaceVitrineCategorias(...args)
}

export const createMarketplaceVitrineAnuncio: ApiModule['createMarketplaceVitrineAnuncio'] = async (...args) => {
  const api = await loadApi()
  return api.createMarketplaceVitrineAnuncio(...args)
}

export const updateMarketplaceVitrineAnuncio: ApiModule['updateMarketplaceVitrineAnuncio'] = async (...args) => {
  const api = await loadApi()
  return api.updateMarketplaceVitrineAnuncio(...args)
}

export const deleteMarketplaceVitrineAnuncio: ApiModule['deleteMarketplaceVitrineAnuncio'] = async (...args) => {
  const api = await loadApi()
  return api.deleteMarketplaceVitrineAnuncio(...args)
}

export const registerMarketplaceVitrineContactClick: ApiModule['registerMarketplaceVitrineContactClick'] = async (...args) => {
  const api = await loadApi()
  return api.registerMarketplaceVitrineContactClick(...args)
}

export const uploadMarketplaceVitrineFoto: ApiModule['uploadMarketplaceVitrineFoto'] = async (...args) => {
  const api = await loadApi()
  return api.uploadMarketplaceVitrineFoto(...args)
}

export const deleteMarketplaceVitrineFoto: ApiModule['deleteMarketplaceVitrineFoto'] = async (...args) => {
  const api = await loadApi()
  return api.deleteMarketplaceVitrineFoto(...args)
}

export const reorderMarketplaceVitrineFotos: ApiModule['reorderMarketplaceVitrineFotos'] = async (...args) => {
  const api = await loadApi()
  return api.reorderMarketplaceVitrineFotos(...args)
}

export const uploadMarketplaceVitrineVideo: ApiModule['uploadMarketplaceVitrineVideo'] = async (...args) => {
  const api = await loadApi()
  return api.uploadMarketplaceVitrineVideo(...args)
}

export const deleteMarketplaceVitrineVideo: ApiModule['deleteMarketplaceVitrineVideo'] = async (...args) => {
  const api = await loadApi()
  return api.deleteMarketplaceVitrineVideo(...args)
}

export const uploadMarketplaceVitrineManual: ApiModule['uploadMarketplaceVitrineManual'] = async (...args) => {
  const api = await loadApi()
  return api.uploadMarketplaceVitrineManual(...args)
}

export const uploadMarketplaceVitrineManuais: ApiModule['uploadMarketplaceVitrineManuais'] = async (...args) => {
  const api = await loadApi()
  return api.uploadMarketplaceVitrineManuais(...args)
}

export const deleteMarketplaceVitrineManual: ApiModule['deleteMarketplaceVitrineManual'] = async (...args) => {
  const api = await loadApi()
  return api.deleteMarketplaceVitrineManual(...args)
}

export const deleteMarketplaceVitrineManualById: ApiModule['deleteMarketplaceVitrineManualById'] = async (...args) => {
  const api = await loadApi()
  return api.deleteMarketplaceVitrineManualById(...args)
}

export const replaceMarketplaceVitrineVariacoes: ApiModule['replaceMarketplaceVitrineVariacoes'] = async (...args) => {
  const api = await loadApi()
  return api.replaceMarketplaceVitrineVariacoes(...args)
}

export const getMarketplaceVitrineSellerPerguntas: ApiModule['getMarketplaceVitrineSellerPerguntas'] = async (...args) => {
  const api = await loadApi()
  return api.getMarketplaceVitrineSellerPerguntas(...args)
}

export const answerMarketplaceVitrinePergunta: ApiModule['answerMarketplaceVitrinePergunta'] = async (...args) => {
  const api = await loadApi()
  return api.answerMarketplaceVitrinePergunta(...args)
}

export const getBuyerAccessStatus: ApiModule['getBuyerAccessStatus'] = async (...args) => {
  const api = await loadApi()
  return api.getBuyerAccessStatus(...args)
}

export const getPedidoById: ApiModule['getPedidoById'] = async (...args) => {
  const api = await loadApi()
  return api.getPedidoById(...args)
}

export const getIndicadorPedidoDetalheAsAccountOrder: ApiModule['getIndicadorPedidoDetalheAsAccountOrder'] = async (...args) => {
  const api = await loadApi()
  return api.getIndicadorPedidoDetalheAsAccountOrder(...args)
}

export const startIndicatorClientDelegation: ApiModule['startIndicatorClientDelegation'] = async (...args) => {
  const api = await loadApi()
  return api.startIndicatorClientDelegation(...args)
}

export const getBuyerPasswordChangeDestinations: ApiModule['getBuyerPasswordChangeDestinations'] = async (...args) => {
  const api = await loadApi()
  return api.getBuyerPasswordChangeDestinations(...args)
}

export const requestBuyerPasswordChangeCode: ApiModule['requestBuyerPasswordChangeCode'] = async (...args) => {
  const api = await loadApi()
  return api.requestBuyerPasswordChangeCode(...args)
}

export const verifyBuyerPasswordChangeCode: ApiModule['verifyBuyerPasswordChangeCode'] = async (...args) => {
  const api = await loadApi()
  return api.verifyBuyerPasswordChangeCode(...args)
}

export const resetBuyerPassword: ApiModule['resetBuyerPassword'] = async (...args) => {
  const api = await loadApi()
  return api.resetBuyerPassword(...args)
}

export const createBuyerPriceTableAccessLink: ApiModule['createBuyerPriceTableAccessLink'] = async (...args) => {
  const api = await loadApi()
  return api.createBuyerPriceTableAccessLink(...args)
}

export const getBuyerBeneficios: ApiModule['getBuyerBeneficios'] = async (...args) => {
  const api = await loadApi()
  return api.getBuyerBeneficios(...args)
}

export const getBuyerDistribuicao: ApiModule['getBuyerDistribuicao'] = async (...args) => {
  const api = await loadApi()
  return api.getBuyerDistribuicao(...args)
}

export const getBuyTogetherProducts: ApiModule['getBuyTogetherProducts'] = async (...args) => {
  const api = await loadApi()
  return api.getBuyTogetherProducts(...args)
}

export const getFinanceiro: ApiModule['getFinanceiro'] = async (...args) => {
  const api = await loadApi()
  return api.getFinanceiro(...args)
}

export const getCarrinhoQuantidades: ApiModule['getCarrinhoQuantidades'] = async (...args) => {
  const api = await loadApi()
  return api.getCarrinhoQuantidades(...args)
}

export const getCarrinhoProducts: ApiModule['getCarrinhoProducts'] = async (...args) => {
  const api = await loadApi()
  return api.getCarrinhoProducts(...args)
}

export const getCheckoutCustomerProfile: ApiModule['getCheckoutCustomerProfile'] = async (...args) => {
  const api = await loadApi()
  return api.getCheckoutCustomerProfile(...args)
}

export const getLancamentosPage: ApiModule['getLancamentosPage'] = async (...args) => {
  const api = await loadApi()
  return api.getLancamentosPage(...args)
}

export const getLancamentos: ApiModule['getLancamentos'] = async (...args) => {
  const api = await loadApi()
  return api.getLancamentos(...args)
}

export const getOrcamentoById: ApiModule['getOrcamentoById'] = async (...args) => {
  const api = await loadApi()
  return api.getOrcamentoById(...args)
}

export const getMenu: ApiModule['getMenu'] = async (...args) => {
  const api = await loadApi()
  return api.getMenu(...args)
}

export const getMenuTopLevel: ApiModule['getMenuTopLevel'] = async (...args) => {
  const api = await loadApi()
  return api.getMenuTopLevel(...args)
}

export const getProductById: ApiModule['getProductById'] = async (...args) => {
  const api = await loadApi()
  return api.getProductById(...args)
}

export const getProductsByIds: ApiModule['getProductsByIds'] = async (...args) => {
  const api = await loadApi()
  return api.getProductsByIds(...args)
}

export const getProductVariations: ApiModule['getProductVariations'] = async (...args) => {
  const api = await loadApi()
  return api.getProductVariations(...args)
}

export const getProductSiteDescriptionHtml: ApiModule['getProductSiteDescriptionHtml'] = async (...args) => {
  const api = await loadApi()
  return api.getProductSiteDescriptionHtml(...args)
}

export const getPasswordlessDestinations: ApiModule['getPasswordlessDestinations'] = async (...args) => {
  const api = await loadApi()
  return api.getPasswordlessDestinations(...args)
}

export const getPasswordRecoveryDestinations: ApiModule['getPasswordRecoveryDestinations'] = async (...args) => {
  const api = await loadApi()
  return api.getPasswordRecoveryDestinations(...args)
}

export const getProducts: ApiModule['getProducts'] = async (...args) => {
  const api = await loadApi()
  return api.getProducts(...args)
}

export const getRelatedProducts: ApiModule['getRelatedProducts'] = async (...args) => {
  const api = await loadApi()
  return api.getRelatedProducts(...args)
}

export const getRelatedProductsByActivity: ApiModule['getRelatedProductsByActivity'] = async (...args) => {
  const api = await loadApi()
  return api.getRelatedProductsByActivity(...args)
}

export const getStorefrontSiteConfig: ApiModule['getStorefrontSiteConfig'] = async (...args) => {
  const api = await loadApi()
  return api.getStorefrontSiteConfig(...args)
}

export const getStorefrontSiteMetrics: ApiModule['getStorefrontSiteMetrics'] = async (...args) => {
  const api = await loadApi()
  return api.getStorefrontSiteMetrics(...args)
}

export const getStorefrontManufacturerBrands: ApiModule['getStorefrontManufacturerBrands'] = async (...args) => {
  const api = await loadApi()
  return api.getStorefrontManufacturerBrands(...args)
}

export const getStorefrontVehicleBrands: ApiModule['getStorefrontVehicleBrands'] = async (...args) => {
  const api = await loadApi()
  return api.getStorefrontVehicleBrands(...args)
}

export const getStorefrontVehicleModels: ApiModule['getStorefrontVehicleModels'] = async (...args) => {
  const api = await loadApi()
  return api.getStorefrontVehicleModels(...args)
}

export const getStorefrontVehicleYears: ApiModule['getStorefrontVehicleYears'] = async (...args) => {
  const api = await loadApi()
  return api.getStorefrontVehicleYears(...args)
}

export const resolveStorefrontVehicleByPlate: ApiModule['resolveStorefrontVehicleByPlate'] = async (...args) => {
  const api = await loadApi()
  return api.resolveStorefrontVehicleByPlate(...args)
}

export const login: ApiModule['login'] = async (...args) => {
  const api = await loadApi()
  return api.login(...args)
}

export const loginLegacyCheckout: ApiModule['loginLegacyCheckout'] = async (...args) => {
  const api = await loadApi()
  return api.loginLegacyCheckout(...args)
}

export const requestPasswordlessLogin: ApiModule['requestPasswordlessLogin'] = async (...args) => {
  const api = await loadApi()
  return api.requestPasswordlessLogin(...args)
}

export const requestPasswordRecoveryCode: ApiModule['requestPasswordRecoveryCode'] = async (...args) => {
  const api = await loadApi()
  return api.requestPasswordRecoveryCode(...args)
}

export const requestPasswordlessContact: ApiModule['requestPasswordlessContact'] = async (...args) => {
  const api = await loadApi()
  return api.requestPasswordlessContact(...args)
}

export const verifyPasswordlessLogin: ApiModule['verifyPasswordlessLogin'] = async (...args) => {
  const api = await loadApi()
  return api.verifyPasswordlessLogin(...args)
}

export const verifyPasswordRecoveryCode: ApiModule['verifyPasswordRecoveryCode'] = async (...args) => {
  const api = await loadApi()
  return api.verifyPasswordRecoveryCode(...args)
}

export const resetPasswordWithRecoveryToken: ApiModule['resetPasswordWithRecoveryToken'] = async (...args) => {
  const api = await loadApi()
  return api.resetPasswordWithRecoveryToken(...args)
}

export const relateClientes: ApiModule['relateClientes'] = async (...args) => {
  const api = await loadApi()
  return api.relateClientes(...args)
}

export const removeFromCarrinho: ApiModule['removeFromCarrinho'] = async (...args) => {
  const api = await loadApi()
  return api.removeFromCarrinho(...args)
}

export const salvarOrcamento: ApiModule['salvarOrcamento'] = async (...args) => {
  const api = await loadApi()
  return api.salvarOrcamento(...args)
}

export const prepararOrcamentosAtivos: ApiModule['prepararOrcamentosAtivos'] = async (...args) => {
  const api = await loadApi()
  return api.prepararOrcamentosAtivos(...args)
}

export const getQuoteClientDirectory: ApiModule['getQuoteClientDirectory'] = async (...args) => {
  const api = await loadApi()
  return api.getQuoteClientDirectory(...args)
}

export const searchProducts: ApiModule['searchProducts'] = async (...args) => {
  const api = await loadApi()
  return api.searchProducts(...args)
}

export const searchProductsByImage: ApiModule['searchProductsByImage'] = async (...args) => {
  const api = await loadApi()
  return api.searchProductsByImage(...args)
}

export const expandProductsWithParentContexts: ApiModule['expandProductsWithParentContexts'] = async (...args) => {
  const api = await loadApi()
  return api.expandProductsWithParentContexts(...args)
}

export const searchProductsPage: ApiModule['searchProductsPage'] = async (...args) => {
  const api = await loadApi()
  return api.searchProductsPage(...args)
}

export const upsertCarrinhoItemByKey: ApiModule['upsertCarrinhoItemByKey'] = async (...args) => {
  const api = await loadApi()
  return api.upsertCarrinhoItemByKey(...args)
}

export const upsertCarrinhoItemsBatch: ApiModule['upsertCarrinhoItemsBatch'] = async (...args) => {
  const api = await loadApi()
  return api.upsertCarrinhoItemsBatch(...args)
}

export const updateCarrinho: ApiModule['updateCarrinho'] = async (...args) => {
  const api = await loadApi()
  return api.updateCarrinho(...args)
}

export const recalculateCarrinho: ApiModule['recalculateCarrinho'] = async (...args) => {
  const api = await loadApi()
  return api.recalculateCarrinho(...args)
}
